module.exports = __webpack_public_path__ + "img/10.9700e640.png";